import { useEffect, useRef } from 'react';

/** A ref that is true while the component is mounted, to skip state updates after an async call outlives it. */
export function useMounted() {
  const mounted = useRef(false);
  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  return mounted;
}
